export const defaultThumbnailWidth = 300;
